import { isUpdateFunnelSegmentEventsActivated } from '~/util/optimizelyHelpers';
import { getUserUuid } from '~/util/getUserUuid';

export type ProductType = 'Home' | 'Auto' | 'Bundle' | 'Home + Auto';

export default function productType(application: ApplicationQuery): ProductType {
  const { hasHome, hasAuto } = application;

  if (!hasHome && !hasAuto) {
    return null;
  } else if (!hasHome && hasAuto) {
    return 'Auto';
  } else if (hasHome && !hasAuto) {
    return 'Home';
  }

  if (isUpdateFunnelSegmentEventsActivated(getUserUuid())) {
    return 'Bundle';
  }

  return 'Home + Auto';
}
